export const DATABASE_REQUIREMENTS_REQUEST = "DATABASE_REQUIREMENTS_REQUEST";
export const DATABASE_REQUIREMENTS_SUCCESS = "DATABASE_REQUIREMENTS_SUCCESS";
export const DATABASE_REQUIREMENTS_FAILURE = "DATABASE_REQUIREMENTS_FAILURE";
